import { Api } from './axios-config';

export interface ICaixaView {
  id: number;
  businessId: number;
  businessName: string;
  openedAt: Date;
  closedAt?: Date;
  openingBalance: number;
  closingBalance?: number;
  isOpen: boolean;
  openedByName: string;
  closedByName: string;
  totalDinheiro: number;
  totalPix: number;
  totalDebito: number;
  totalCredito: number;
  totalOutro: number;
  totalGeral: number;
  totalIncome: number;
  totalExpense: number;
}

export interface ICreateCaixaDto {
  businessId: number;
  openingBalance: number;
}

export interface ICloseCaixaDto {
  id: number;
  businessId: number;
  closingBalance: number;
}

const open = async (body: ICreateCaixaDto): Promise<number> => {
  try {
    const { data } = await Api.post<number>('/caixa/open', body);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getCurrent = async (businessId: number): Promise<ICaixaView | null> => {
  try {
    const { data } = await Api.get<ICaixaView>(`/caixa/current?businessId=${businessId}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const getByBusiness = async (businessId: number, startDate?: Date, endDate?: Date): Promise<ICaixaView[]> => {
  try {
    const params = new URLSearchParams();
    params.append('businessId', businessId.toString());
    if (startDate) params.append('startDate', startDate.toISOString());
    if (endDate) params.append('endDate', endDate.toISOString());

    const { data } = await Api.get<ICaixaView[]>(`/caixa?${params.toString()}`);
    return data;
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

const close = async (body: ICloseCaixaDto): Promise<void> => {
  try {
    await Api.post('/caixa/close', body);
  } catch (error: unknown) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const caixaService = {
  open,
  getCurrent,
  getByBusiness,
  close,
};